import { gql } from "@apollo/client";

export const SCHEDULE_INSTANCES_QUERY = gql`
  query scheduleInstances($scenarioId: ID!, $originId: ID!, $filter: ScheduleInstanceFilterInput!) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      scheduleInstances(filter: $filter) {
        date
        day
        startingTime
        endingTime
        interval {
          id
          name
          startingDate
          endingDate
          __typename
        }
        sections {
          id
          code
          component {
            id
            code
            __typename
          }
          sessions {
            id
            blocksCount
            blocks {
              id
              startingTime
              endingTime
            }
            classrooms {
              id
              code
              name
              classroomType {
                id
                code
                name
                __typename
              }
              building {
                id
                code
                name
                campus {
                  id
                  code
                  name
                  __typename
                }
                __typename
              }
              floor
              usable
              __typename
            }
            instructors {
              id
              name
              code
              __typename
            }
          }
        }
      }
    }
  }
`;
